/* Virtual Firewall - wires home href="#" links at runtime (home.liquid is user-uploaded, too big to API-edit) + normalizes the agreement checkbox label. */
(function(){
  "use strict";
  var RES={
    "What is a virtual firewall?":"/blogs/resources/what-is-a-virtual-firewall",
    "NinjaToolKit, explained":"/blogs/resources/what-is-ninjatoolkit",
    "Virtual Firewall or an on-site firewall?":"/blogs/resources/virtual-firewall-or-on-site-firewall",
    "Firewall protection for card payments":"/blogs/resources/firewall-protection-for-card-payments",
    "Before your device arrives":"/blogs/resources/before-your-device-arrives",
    "Adding a second location":"/blogs/resources/adding-a-second-location"
  };
  var MSA="https://cdn.shopify.com/s/files/1/0680/4943/6783/files/BLANK_-_MSA_-_US25P.pdf?v=1778071447";
  function setHref(a,h){ if(a&&h){ var c=a.getAttribute("href"); if(!c||c==="#"||c===""){ a.setAttribute("href",h); } } }
  function wire(){
    document.querySelectorAll(".rsrc__t").forEach(function(t){ var a=t.closest("a"); if(a){ var h=RES[(t.textContent||"").trim()]; if(h) setHref(a,h); } });
    document.querySelectorAll('a[href="#"], a[href=""]').forEach(function(a){
      var tx=(a.textContent||"").trim().toLowerCase();
      if(tx.indexOf("contact us")>=0) setHref(a,"/pages/contact");
      else if(tx.indexOf("learn how it works")>=0) setHref(a,"/blogs/resources/what-is-ninjatoolkit");
      else if(tx.indexOf("guard depot")>=0) setHref(a,"https://svqb02-95.myshopify.com");
    });
    var lab=document.querySelector(".gdn__agree");
    if(lab){
      var ts=[].filter.call(lab.children,function(el){ return el.tagName==="SPAN" && (el.className||"").indexOf("gdn__cb")<0; })[0];
      if(ts){ ts.innerHTML='I agree to eMazzanti Technologies&rsquo; <a href="'+MSA+'" target="_blank" rel="noopener">Master Service Agreement</a>, <a href="/pages/terms-of-use">Terms</a>, and <a href="/pages/privacy-policy">Privacy Policy</a>.'; }
    }
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", wire); else wire();
})();